<template>
  <div>    
    <transition name="modal" v-if="carregando">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
            <label>Aguarde. Carregando.</label>
          </div>
        </div>
      </div>
    </transition>

    <div class="wrapper fora" v-else>
      
      <div class="topo-header centro so-tela">
        <div style="display: flex; align-items: center;">
          <botao-voltar class="voltar" nomeRota="CargosColegiados"/>
          <h1>Visualizar Cargo</h1>
        </div>
        
        <div class="acoes-topo">          
          <!-- Botão Novo Cargo padronizado com a classe btn-novo e sem o "+" -->
          <router-link :to="{ name: 'CargoColegiadoNew' }" v-if="permissoes.pode_criar" class="btn-acao btn-novo" title="Novo Cargo">
            + Novo Cargo
          </router-link>
          
          <router-link :to="{ name: 'CargoColegiadoEdit', params: { id: cargoColegiado.id } }" v-if="permissoes.pode_editar">
            <button class="btn-acao btn-editar" title="Editar">Editar</button>
          </router-link>
          
          <button class="btn-acao btn-excluir" title="Excluir" @click.prevent="modalExclusaoVisivel = true" v-if="permissoes.pode_deletar">Excluir</button>
        </div>
      </div>

      
      <div class="form centro">
        <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
        <div class="conteudo-cards">
          
          <!-- GRADE 1: DADOS BÁSICOS NO NOVO PADRÃO -->
          <div class="painel-dados" style="margin-bottom: 1.5rem;">
            <div class="secao-dados">
              <h2 class="secao-titulo">Informações Gerais</h2>
              <div class="grade-dados">
                
                <!-- NOME DO CARGO (Ocupa a linha inteira) -->
                <div class="item-dado item-dado--largo">
                  <span class="item-rotulo">Nome do Cargo</span>
                  <span class="item-valor">{{ cargoColegiado.nome || '-' }}</span>                    
                </div>
                
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- ================== MODAL DE EXCLUSÃO ================== -->
      <div v-if="modalExclusaoVisivel" class="modal-exclusao">
        <div class="modal-mask">
          <div class="modal-container">
            <div class="modal-header">
              <h2>Deseja mesmo excluir este Cargo?</h2>
            </div>
            <div class="modal-body">
              <p>Dados Básicos do Cargo:</p>
              <div class="dados">
                <div class="flexbox">
                  <div class="texto-centralizado">
                    Nome do Cargo: <span>{{ cargoColegiado.nome || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn-confirmar-exclusao" @click="confirmarExclusao">Sim</button>
              <button class="btn-cancelar-exclusao" @click="modalExclusaoVisivel = false">Não</button>
            </div>
          </div>
        </div>
      </div>
      <!-- ======================================================= -->

      <div style="margin-top: 2rem;">        
        <Footer
          :createdByLabel="'Criado por'"
          :criadoPor="cargoColegiado.criado_por"
          :lastUpdatedByLabel="'Última atualização feita por'"
          :atualizadoPor="cargoColegiado.atualizado_por"
          :emLabel="' em '"
          :SistemaLabel="'Sistema'"
          :created_at="cargoColegiado.created_at"
          :updated_at="cargoColegiado.updated_at"
        />
      </div>
    </div>  
  </div>
</template>

<script>
  import BotaoVoltar from "../BotaoVoltar.vue";
  import CargoColegiadoApi from "../../services/CargoColegiadoApi";
  import { parseISO, format } from "date-fns";
  import Footer from "../Footer.vue";
  import MsgErroFormularios from "../MsgErroFormularios";

  export default {
    name: "ExibirCargoColegiado",
    props: {      
      cargoColegiado: {
        type: Object,
        required: true
      },
      temPermissao: {
        type: Boolean,
        default: false
      },
      permissoes: {
        type: Object,
        default: () => ({
          pode_criar: true,
          pode_editar: true,
          pode_deletar: true
        })
      }
    },
    data() {
      return{
        carregando: false,
        modalExclusaoVisivel: false,
        erro: false,
        msgErros: null,
      }
    },
    created() {
      this.cargoColegiadoApi = new CargoColegiadoApi();
    },
    methods: {
      formatarDataHora: function(value) {
        if(!value) return '-';
        return format(parseISO(value), "dd/MM/yyyy") + " às " + format(parseISO(value), "HH:mm:ss.");
      },
      
      async confirmarExclusao() {
        try {
          if (this.cargoColegiadoApi.cancelTokens && this.cargoColegiadoApi.cancelTokens.destroyCargoColegiado) {
            this.cargoColegiadoApi.cancelTokens.destroyCargoColegiado.cancel();
          }
          
          await this.cargoColegiadoApi.destroyCargoColegiado(this.cargoColegiado.id);
          
          this.modalExclusaoVisivel = false;
          
          this.$router.push({ name: "CargoColegiado" }); 
          
        } catch (err) {
          if (this.cargoColegiadoApi.isCancel && this.cargoColegiadoApi.isCancel(err)) return;
          
          // 1. Esconde a modal de confirmação
          this.modalExclusaoVisivel = false;
          
          // 2. Aciona o estado de erro
          this.erro = true;
          
          // 3. Força a mensagem amigável no objeto msgErros
          this.msgErros = {
            cargoColegiado: "Não foi possível excluir este cargo. Ele pode estar vinculado a um mandato ou colegiado ativo."
          };
          
          // 4. Faz scroll para o topo para o utilizador ver o erro
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      },
      
      // Função para fechar a caixa de erro ao clicar no "X"
      fecharErro() {
        this.erro = false;
        this.msgErros = null;
      }
    },
    components: { 
      BotaoVoltar,
      Footer,
      MsgErroFormularios,
    },
  };
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
    font-family: 'Karla', sans-serif;
}

/*  BOTÕES DE AÇÃO NO TOPO (PADRONIZADOS) */
.acoes-topo {
  display: flex;
  gap: 0.5rem;
  align-items: center;

  /* Classe base aplicada a todos os botões (Novo, Editar e Excluir) */
  .btn-acao {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    box-sizing: border-box;
    
    font-family: "Montserrat-Medium", sans-serif;
    font-size: 0.9rem;
    padding: 0.2rem 1rem;
    border-radius: 0.2rem;
    cursor: pointer;
    background: transparent;
    transition: 0.2s;
  }

  /* 1. Botão Novo Membro */
  .btn-novo {
    color: #005516;
    border: #005516 solid 0.15rem;

    &:hover {
      color: white;
      background-color: #005516;
    }
  }

  /* 2. Botão Editar */
  .btn-editar {
    color: #005516;
    border: #005516 solid 0.15rem;

    &:hover {
      color: white;
      background-color: #005516;
    }
  }

  /* 3. Botão Excluir */
  .btn-excluir {
    color: #d32f2f;
    border: #d32f2f solid 0.15rem;

    &:hover {
      color: white;
      background-color: #d32f2f;
    }
  }
}


/* NOVOS ESTILOS DO SISTEMA DE CARDS (GRID) */
.painel-dados {
  display: grid;
  gap: 0.85rem;
  margin-top: 1.5rem;
}

.secao-dados {
  background: #fff;
  border: 1px solid #d9e2db;
  border-radius: 0.5rem;
  padding: 0.85rem 1rem 1rem;
  width: 100%;
  box-sizing: border-box;
}

.secao-titulo {
  margin: 0 0 0.75rem 0;
  padding: 0 0 0.4rem 0;
  border-bottom: 1px solid #e2eae4;
  font-family: "Montserrat-Bold", sans-serif;
  font-size: 0.98rem;
  color: #0a4a22;
  letter-spacing: 0.01em;
  text-transform: uppercase;
}

.grade-dados {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr)); 
  gap: 0.85rem 1rem;
}

.item-dado {
  min-width: 0;
  padding: 0.4rem 0.6rem;
  background: #f7f9f7;
  border: 1px solid #e4ebe5;
  border-radius: 0.4rem;
}

.item-rotulo {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin: 0 0 0.15rem 0;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.96rem;
  line-height: 1.2;
  color: #005516;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.item-valor {
  display: block;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.9rem;
  line-height: 1.3;
  color: #1f1f1f;
  word-break: break-word;
  white-space: pre-wrap;
}

.item-dado--span2 { grid-column: span 2; }
.item-dado--largo { grid-column: 1 / -1; }

/*  ESTILOS DO MODAL DE EXCLUSÃO */
.modal-exclusao {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex; 
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;

  .modal-mask {
    border-radius: 1rem;
    position: relative;
    z-index: 1000;
    width: 40%;
    max-height: 25vh;
    background-color: #f2f2f2;
    display: flex; 
    flex-direction: column;
  }

  .modal-container {
    padding: .7rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    font-family: "Montserrat-Medium", sans-serif;

    .modal-header h2 {
      font-size: 1.3rem;
      font-weight: bold;
      text-align: center;
      margin-top: 1rem;
      flex-shrink: 0;
    }

    .modal-body {
      border: 1px solid gray;
      border-radius: 1rem;
      text-align: center;
      margin: 1rem;
      padding-bottom: 1rem;
      overflow-y: auto;
      flex-grow: 1;

      p {
        font-size: 1rem;
        font-weight: bold;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        color: #005516;
      }

      .dados {
        text-align: left;
        margin-left: 1rem;
        padding-right: 1rem;
        
        .flexbox {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.5rem 1.5rem;
          margin-bottom: 0.5rem;
        }

        .texto-centralizado {
          font-weight: bold;
          font-size: 0.95rem;
          color: #000;
          word-break: break-word;
        }

        span {
          font-weight: normal;
          font-size: 0.9rem;
          margin-left: 0.3rem;
          color: #333;
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: space-evenly;
      margin-bottom: 1rem;
      flex-shrink: 0;

      .btn-confirmar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #005516;
        color: #f2f2f2;
        cursor: pointer;
      }

      .btn-cancelar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #bd0000;
        color: #f2f2f2;
        cursor: pointer;
      }
    }
  }
}

/* ESTRUTURA GLOBAL E RESPONSIVIDADE (Padrão Colegiados) */

.fora, 
.wrapper, 
.form, 
.form.centro, 
.topo-header {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

/* Espaçamento principal */
.fora {
  width: 100% !important; 
  max-width: 100% !important;  
  padding: 1.5rem 0 !important; 
  margin: 0 !important; 
  min-height: calc(100vh - 10rem);
}

.wrapper {
  padding: 1.5rem 0 !important; /* Mantém o espaço da faixa verde superior */
  margin: 0 auto !important;
  border: none !important;
}

.form.centro,
.centro {
  width: 96vw !important;
  max-width: 96vw !important;
  margin: 0 auto !important;
  padding: 0 !important;
}

/* Alinhamento do cabeçalho */
.topo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;

  h1 {
    font-family: "Montserrat-Medium";
    font-weight: bold;
    color: #ffa600;
    margin-left: 0.75rem;
    font-size: 1.8rem;
  }
}

/*  AJUSTES PARA TELAS MENORES (Celulares e Tablets) */
@media screen and (max-width: 1065px) {  
  .form.centro,
  .centro {
    width: 90vw !important;
    max-width: 90vw !important;
  }

  .topo-header {
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    h1 {
      margin-left: 0;
      font-size: 1.5rem;
    }
  }

  .acoes-topo {
    flex-direction: column;
    width: 100%;
    
    .btn-novo-original, .btn-acao {
      width: 100%;
      justify-content: center;
    }
  }

  .grade-dados {
    grid-template-columns: 1fr;
  }

  .modal-exclusao .modal-mask {
    width: 85%;
  }
}

@media screen and (max-width: 600px) {
  .modal-exclusao .modal-mask {
    width: 95%;
  }
}

/* Loading Modal base */
.modal-mask {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>